<template>
    <h1 class="page_title text_center">
        {{ value }}
    </h1>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        }
    }
};
</script>
